/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CommerceModeEnum = 'LEGACY_EVAL' | 'LEGACY_STANDARD' | 'LEGACY_ENTERPRISE' | 'LEGACY_CLOUD' | 'LEGACY_TERM' | 'LEGACY_UNKNOWN' | 'CLOUD_TRIAL' | 'CLOUD_TRIAL_DEGRADED' | 'CLOUD_TRIAL_EXPIRED' | 'CLOUD_SUB' | 'CLOUD_SUB_DEGRADED' | 'CLOUD_SUB_SUSPENDED' | 'DISCONNECTED_SUB' | 'DISCONNECTED_SUB_DEGRADED' | 'DISCONNECTED_SUB_SUSPENDED' | 'DISCONNECTED_SUB_WARNING' | 'DISCONNECTED_SUB_GRACE' | 'DISCONNECTED_SUB_TERMINATED';

export const CommerceModeEnum = {

    LEGACY_EVAL: 'LEGACY_EVAL' as CommerceModeEnum,

    LEGACY_STANDARD: 'LEGACY_STANDARD' as CommerceModeEnum,

    LEGACY_ENTERPRISE: 'LEGACY_ENTERPRISE' as CommerceModeEnum,

    LEGACY_CLOUD: 'LEGACY_CLOUD' as CommerceModeEnum,

    LEGACY_TERM: 'LEGACY_TERM' as CommerceModeEnum,

    LEGACY_UNKNOWN: 'LEGACY_UNKNOWN' as CommerceModeEnum,

    CLOUD_TRIAL: 'CLOUD_TRIAL' as CommerceModeEnum,

    CLOUD_TRIAL_DEGRADED: 'CLOUD_TRIAL_DEGRADED' as CommerceModeEnum,

    CLOUD_TRIAL_EXPIRED: 'CLOUD_TRIAL_EXPIRED' as CommerceModeEnum,

    CLOUD_SUB: 'CLOUD_SUB' as CommerceModeEnum,

    CLOUD_SUB_DEGRADED: 'CLOUD_SUB_DEGRADED' as CommerceModeEnum,

    CLOUD_SUB_SUSPENDED: 'CLOUD_SUB_SUSPENDED' as CommerceModeEnum,

    DISCONNECTED_SUB: 'DISCONNECTED_SUB' as CommerceModeEnum,

    DISCONNECTED_SUB_DEGRADED: 'DISCONNECTED_SUB_DEGRADED' as CommerceModeEnum,

    DISCONNECTED_SUB_SUSPENDED: 'DISCONNECTED_SUB_SUSPENDED' as CommerceModeEnum,

    DISCONNECTED_SUB_WARNING: 'DISCONNECTED_SUB_WARNING' as CommerceModeEnum,

    DISCONNECTED_SUB_GRACE: 'DISCONNECTED_SUB_GRACE' as CommerceModeEnum,

    DISCONNECTED_SUB_TERMINATED: 'DISCONNECTED_SUB_TERMINATED' as CommerceModeEnum
};

